/**
 * Table Component
 * Data display component with sorting and selection
 */

import React from "react";

export interface TableColumn<T = any> {
  key: string;
  header: React.ReactNode;
  cell: (row: T) => React.ReactNode;
  sortable?: boolean;
  width?: string;
}

export interface TableProps<T = any> {
  data: T[];
  columns: TableColumn<T>[];
  loading?: boolean;
  selectable?: boolean;
  selectedRows?: T[];
  onRowSelect?: (rows: T[]) => void;
  onSort?: (key: string, direction: "asc" | "desc") => void;
  emptyState?: React.ReactNode;
  className?: string;
}

export function Table<T>({
  data,
  columns,
  loading = false,
  selectable = false,
  selectedRows = [],
  onRowSelect,
  onSort,
  emptyState,
  className,
  ...props
}: TableProps<T>) {
  // Implementation will be added later
  return (
    <table className={className} {...props}>
      <thead>
        <tr>
          {columns.map((column) => (
            <th key={column.key}>{column.header}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data.map((row, index) => (
          <tr key={index}>
            {columns.map((column) => (
              <td key={column.key}>{column.cell(row)}</td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
}
